import styled from "styled-components";

export const StyledCardContainer = styled.div`
  .container {
    flex: 0 50%;
    border: red solid;
    box-sizing: border-box;
  }
`;

export const StyledProgramOverviewCard = styled.div`
  .MuiTypography-h3 {
    font-family: inherit !important;
    font-size: 18px !important;
    font-weight: 700 !important;
    color: var(--colorTextPrimary) !important;
    max-width: 200px;
  }
`;
